export default __webpack_public_path__ + "static/media/hiperfoco.74b74b8c.png";